import find from 'lodash/find';

export default function getOrgById(state, id) {
  return find(state.orgs.orgs, org => org.id === Number.parseInt(id));
}
